<template>
    <main>

        <!-- breadcrumb-area-start -->
        <div class="it-breadcrumb-area it-breadcrumb-bg"
            :style="{ backgroundImage: 'url(/img/breadcrumb/breadcrumb.png)' }">
            <div class="container">
                <div class="row ">
                    <div class="col-md-12">
                        <div class="it-breadcrumb-content z-index-3 text-center">
                            <div class="it-breadcrumb-title-box">
                                <h3 class="it-breadcrumb-title">Director Message</h3>
                            </div>
                            <div class="it-breadcrumb-list-wrap">
                                <div class="it-breadcrumb-list">
                                    <span><a href="#">home</a></span>
                                    <span class="dvdr">//</span>
                                    <span>Director Message</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- breadcrumb-area-end -->

        <!-- teacher-details-area-start -->
        <div class="it-teacher-details-area pt-120 pb-90">
            <div class="container">
                <div class="it-teacher-details-wrap">
                    <div class="row">
                        <div class="col-xl-3 col-lg-3">
                            <div class="it-teacher-details-left">
                                <div class="it-teacher-details-left-thumb">
                                    <img src="/img/team/director_message.png" alt="">
                                </div>
                                <!-- <div class="it-teacher-details-left-social text-center">
                                    <a href="#"><i class="fab fa-facebook-f"></i></a>
                                    <a href="#"><i class="fab fa-twitter"></i></a>
                                    <a href="#"><i class="fab fa-skype"></i></a>
                                    <a href="#"><i class="fab fa-linkedin-in"></i></a>
                                </div> -->
                                <div class="it-teacher-details-left-info">
                                    <ul>
                                        <li>
                                            <i class="fa-light fa-phone-volume"></i>
                                            <a href="tel:(568)367987237">(91) 9619392909</a>
                                        </li>
                                        <li>
                                            <i class="fa-light fa-location-dot"></i>
                                            <a href="https://www.google.com/maps" target="_blank">Santoshi Mata Mandir
                                                Road, Near New High School, Malhar Nagar, Joshibaug, Kalyan(W)-421
                                                301</a>
                                        </li>
                                        <li>
                                            <i class="fa-light fa-envelope"></i>
                                            <a href="mailto:info@aime.ac.in">info@aime.ac.in</a>
                                        </li>
                                    </ul>
                                </div>
                                <div class="it-teacher-details-left-btn">
                                    <a class="it-btn" href="#">
                                        <span>
                                            Contact us
                                            <svg width="17" height="14" viewBox="0 0 17 14" fill="none"
                                                xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 1.24023L16 7.24023L11 13.2402" stroke="currentcolor"
                                                    stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                                <path d="M1 7.24023H16" stroke="currentcolor" stroke-width="1.5"
                                                    stroke-miterlimit="10" stroke-linecap="round"
                                                    stroke-linejoin="round" />
                                            </svg>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-9 col-lg-9">
                            <div class="it-teacher-details-right">
                                <div class="it-teacher-details-right-title-box">
                                    <h4>Dr. (CA) Mahesh K. Bhiwandikar</h4>
                                    <span>Director and Initiator</span>
                                    <p>I’ve spent years figuring out the “formula” to teaching technical skills in a
                                        classroom
                                        environment, and I’m really excited to finally share my expertise with you. I
                                        can
                                        confidently
                                        say that my online courses are without a doubt the most comprehensive ones on
                                        the market.
                                    </p>
                                    <p>We are promoting all-embracing personality development through inculcation of
                                        communication skills, structured programme on personal grooming and mentoring
                                        for every student in order to develop ability to take right decisions at the
                                        right moment and make students ready to face the acute challenges of global
                                        corporate world.
                                    </p>
                                    <p>Young Indian Minds constitute the next wave of change for our country and the
                                        fact that you have chosen the path of being successful and an Achiever in life
                                        will definitely lead you to the path of success.
                                    </p>
                                </div>
                                <div class="it-teacher-details-right-content mb-40">
                                    <h4>Qualification:</h4>
                                    <p>Ph.D, F.C.A, M.Phil, M.COM
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- teacher-details-area-end -->

        <div class="it-team-3-area it-team-3-style-2 p-relative z-index pb-60">
            <div class="container">
                <div class="row">
                    <div class="col-xl-12">
                        <div class="it-testimonial-5-title-box text-center mb-30">
                            <h4 class="it-section-title-5">Our Expert Mentor Board</h4>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <img src="/img/about/mentor_board.png" alt="">
                </div>
            </div>
        </div>

    </main>
</template>
<script>
export default {
    name: "DirectorMessageView"
};
</script>
